import { request, queryString } from '../util'

const url = '/private/api/dashboards'

export default {
  getCurrentData (filter) {
    return request(`${url}/current`)
  }
}
